import React from 'react';
import * as styles from './expertiseCardSection.module.scss';
import { usePageContext } from '../context/pageContext';
import { ExpertisePagesQuery, SanityExpertiseCardSection } from 'graphql-types';
import { GatsbyImage } from 'gatsby-plugin-image';

import { graphql, useStaticQuery } from 'gatsby';
import { Arrow } from '../arrow/Arrow';
import { LocalLink } from '../html-tag/localLink';
import { Blocks } from '../ui/blocks/Blocks';
import slugify from 'slugify';
import { findTranslation } from '../../utils/findTranslation';
import { constructSlug } from '../../utils/constructSlug';
import { SanityPageExpertise } from '../../../graphql-types';

interface Props {
  section: SanityExpertiseCardSection;
}

export const ExpertiseCardSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();
  if (!section) return null;

  return (
    <div className={styles.wrapper}>
      {section?.activeTopText && (
        <div className={styles.topText}>
          <Blocks blocks={findTranslation(section._rawExpertiseTopText, lang, defaultLang)} />
        </div>
      )}
      <div className={styles.cards}>
        {section?.expertiseCardsList?.map((expertiseCard, index) => {
          const slug = constructSlug({
            destination: expertiseCard?.ctaExpertiseCard as SanityPageExpertise,
          });

          return (
            <div
              className={styles.expertise}
              key={`expertiseCard-${index}`}
            >
              <div className={styles.image}>
                <GatsbyImage
                  alt={expertiseCard?.imgBgExpertiseCard?.alt ?? ''}
                  image={expertiseCard?.imgBgExpertiseCard?.img?.asset?.gatsbyImageData}
                />
                <div className={styles.overlay} />
                <LocalLink
                  to={slug ?? ''}
                  dataType={expertiseCard?.colorNav ?? ''}
                >
                  <div className={styles.title}>
                    <Arrow color={expertiseCard?.colorNav ?? ''} />
                    <h2>
                      {findTranslation(
                        expertiseCard?.ctaExpertiseCard?._rawPageExpertiseTitle,
                        lang,
                        defaultLang,
                      )}
                    </h2>
                  </div>
                </LocalLink>
              </div>
            </div>
          );
        })}
      </div>
      {section?.activeBottom && (
        <div>
          <Blocks blocks={findTranslation(section._rawExpertiseBottomText, lang, defaultLang)} />
        </div>
      )}
    </div>
  );
};

export const EXPERTISEPAGESLUG = graphql`
  query ExpertisePages {
    sanityFunctionButton {
      _rawLearnMore(resolveReferences: { maxDepth: 10 })
    }
    allSanityPage {
      nodes {
        id
        _rawPageSlug(resolveReferences: { maxDepth: 10 })
        pagesExpertiseList {
          id
          _rawPageExpertiseSlug(resolveReferences: { maxDepth: 10 })
          pagesProductList {
            id
            _rawPageProductSlug(resolveReferences: { maxDepth: 10 })
          }
        }
      }
    }
  }
`;
